import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { LoginPage } from './pages/LoginPage'
import { TermsPage } from './pages/TermsPage'
import { MenuPage } from './pages/MenuPage'
import { AssessmentPage } from './pages/AssessmentPage'
import { CompletionPage } from './pages/CompletionPage'
import { FacilitadorPage } from './pages/FacilitadorPage'
import { AdminPage } from './pages/AdminPage'

// Guarda para participantes logados (token de acesso)
function PrivateRoute({ children }: { children: React.ReactNode }) {
  const token = sessionStorage.getItem('token')
  return token ? <>{children}</> : <Navigate to="/login" replace />
}

// Guarda para páginas de facilitador/admin (sessão better-auth)
function AdminRoute({ children }: { children: React.ReactNode; role: 'admin' | 'facilitador' }) {
  // A própria página exibe o gate de login se baToken não existir
  return <>{children}</>
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Autenticação */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* Fluxo do participante — requer token */}
        <Route path="/terms" element={<PrivateRoute><TermsPage /></PrivateRoute>} />
        <Route path="/menu" element={<PrivateRoute><MenuPage /></PrivateRoute>} />
        <Route path="/assessment" element={<PrivateRoute><AssessmentPage /></PrivateRoute>} />
        <Route path="/completion" element={<PrivateRoute><CompletionPage /></PrivateRoute>} />

        {/* Facilitador e Admin — requer login de role */}
        <Route path="/facilitador" element={<AdminRoute role="facilitador"><FacilitadorPage /></AdminRoute>} />
        <Route path="/admin" element={<AdminRoute role="admin"><AdminPage /></AdminRoute>} />

        {/* Legacy redirects */}
        <Route path="/dashboard" element={<Navigate to="/menu" replace />} />
        <Route path="/fim" element={<Navigate to="/completion" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
